import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';

import axios from 'helpers/axios';
import { AppState } from 'store/configureStore';

/**
 * Данные текущего залогиненного админа.
 * user_id берётся из JWT, затем подтягивается профиль через /api/adminapi/user/{id}/.
 * Тот же query-key и staleTime, что в Dashboard — React Query переиспользует кэш без лишних запросов.
 */
export const useCurrentUser = () => {
    const accessToken = useSelector((state: AppState) => state.auth.access);

    const userId = useMemo(() => {
        try {
            const payload = JSON.parse(atob(accessToken.split('.')[1]));
            return payload.user_id;
        } catch {
            return null;
        }
    }, [accessToken]);

    const { data: userInfo } = useQuery(
        ['user', userId],
        async () => {
            const { data } = await axios.get(`/api/adminapi/user/${userId}/`);
            return data;
        },
        { enabled: !!userId, staleTime: Infinity }
    );

    return { userId, userInfo, username: userInfo?.username || '' };
};
